export default __webpack_public_path__ + "static/media/Aerosimple - New Badge Application.31d6cfe0.title";